import { render, staticRenderFns } from "./StaticAbout.vue?vue&type=template&id=af6a7372&"
import script from "./StaticAbout.vue?vue&type=script&lang=js&"
export * from "./StaticAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports